import { getData } from "./index.svc"

export const getEmployeesService = async (showAll = false) => {
  const qs = showAll ? '?all=1' : ''
  return await getData(`employees${qs}`)
}

export const createEmployeeService = async (body) => await getData('employees', 'POST', body)

export const createSimpleEmployeeService = async (body) => await getData('employees/simple', 'POST', body)

export const updateEmployeeService = async (id, body) => await getData(`employees/${id}`, 'POST', body)

export const deleteEmployeeService = async(id) => await getData(`employees/${id}?Active=No`, 'DELETE')

export const resetEmployeeService = async(id) => await getData(`employees/${id}?Active=Yes`, 'DELETE')